import { useEffect, useState } from "react";
import styled from "styled-components";
import CustomSelect from "./select";

const Div = styled.div`
  width: 100%;
  margin-top: 10px;
  margin-bottom: 10px;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const CheckBoxDiv = styled.div`
  width: 25%;
  display: flex;
  align-items: center;
`;

const Title = styled.h6``;

const SizeCheck = styled.div`
  width: 75%;
  display: flex;
  align-items: center;
  & input {
    display: none;
  }
`;

const SizeLable = styled.label`
  font-size: 1rem;
  padding: 10px 20px;
  overflow: hidden;
  border: 1px solid #ececec;
  background-color: ${(props) => (props.checked ? "#3bb77e" : "#fff")};
  color: ${(props) => (props.checked ? "#fff" : "6c757da5")};
  border-color: ${(props) => (props.checked ? "#3bb77e" : "#ececec")};
  :last-of-type {
    border-right: 1px solid #ececec;
  }
  cursor: pointer;
`;

const CustomPrint = ({
  title,
  code,
  options,
  openModal,
  register,
  reset,
  getValues,
  formState,
  watch,
  detailData,
}) => {
  const [checkedSide, setCheckedSide] = useState(
    new Array(options.length).fill("")
  );
  const [selectedSize, setSelectedSize] = useState(
    new Array(options.length).fill("")
  );

  const onChangeCheckbox = (i) => (e) => {
    const tempArr = [...checkedSide];
    tempArr[i] = e.target.checked;
    setCheckedSide(tempArr);
    selectedSize[i] = "";
    if (!e.target.checked) {
      const tempArr2 = getValues(code) == undefined ? [] : [...getValues(code)];
      tempArr2[i] = undefined;
      reset({
        ...getValues(),
        [code]: [...tempArr2.filter((el) => el !== undefined)],
      });
    }
  };

  const onChangeCheckSize = (el, i) => (e) => {
    const tempArr = [...selectedSize];
    tempArr[i] = e.target.value;
    setSelectedSize(tempArr);
    if (checkedSide[i]) {
      const tempArr2 = getValues(code) == undefined ? [] : [...getValues(code)];
      tempArr2[i] = { key: el.okey, value: e.target.value };
      reset({
        ...getValues(),
        [code]: [...tempArr2.filter((el) => el !== undefined)],
      });
    }
  };

  const printCheck = () => {
    return (
      watch("T0006") ===
        detailData.Row.find((el) =>
          el.data.find((item) => item.code === "T0006")
        )
          .data.find((el) => el.code === "T0006")
          .options.find((el) => el.oname === "무인쇄")?.okey ||
      watch("T0006") === "" ||
      getValues("T0006") === undefined
    );
  };

  useEffect(() => {
    if (printCheck()) {
      setSelectedSize(new Array(options.length).fill(""));
      setCheckedSide(new Array(options.length).fill(""));
    }
  }, [printCheck()]);

  return (
    <>
      {printCheck() !== true && (
        <>
          {options.map((el, i) => (
            <Div key={i}>
              <CheckBoxDiv className="custome-checkbox">
                <input
                  type="checkbox"
                  id={`${code}${i}`}
                  className="form-check-input"
                  onChange={onChangeCheckbox(i)}
                  disabled={printCheck()}
                />
                <label
                  className="form-check-label"
                  htmlFor={`${code}${i}`}
                  style={{
                    textTransform: "capitalize",
                  }}
                />
                <Title>{el.oname}</Title>
              </CheckBoxDiv>
              <SizeCheck>
                <input
                  type="checkbox"
                  id={`large${i}`}
                  name="printLarge"
                  className="form-check-input"
                  value="large"
                  checked={selectedSize[i] && selectedSize[i] === "large"}
                  onChange={onChangeCheckSize(el, i)}
                  disabled={!checkedSide[i]}
                />
                <SizeLable
                  selectedSize={selectedSize}
                  className="form-check-label"
                  htmlFor={`large${i}`}
                  value="large"
                  checked={checkedSide[i] && selectedSize[i] === "large"}
                  style={{
                    textTransform: "capitalize",
                  }}
                >
                  대
                </SizeLable>
                <input
                  type="checkbox"
                  id={`medium${i}`}
                  name={title}
                  className="form-check-input"
                  value="medium"
                  checked={selectedSize[i] && selectedSize[i] === "medium"}
                  onChange={onChangeCheckSize(el, i)}
                  disabled={!checkedSide[i]}
                />
                <SizeLable
                  selectedSize={selectedSize}
                  value="medium"
                  className="form-check-label"
                  htmlFor={`medium${i}`}
                  checked={checkedSide[i] && selectedSize[i] === "medium"}
                  style={{
                    textTransform: "capitalize",
                  }}
                >
                  중
                </SizeLable>
                <input
                  type="checkbox"
                  id={`small${i}`}
                  name={title}
                  className="form-check-input"
                  value="small"
                  checked={selectedSize[i] && selectedSize[i] === "small"}
                  onChange={onChangeCheckSize(el, i)}
                  disabled={!checkedSide[i]}
                />
                <SizeLable
                  selectedSize={selectedSize}
                  className="form-check-label"
                  htmlFor={`small${i}`}
                  value="small"
                  checked={checkedSide[i] && selectedSize[i] === "small"}
                  style={{
                    textTransform: "capitalize",
                  }}
                >
                  소
                </SizeLable>
              </SizeCheck>
            </Div>
          ))}
        </>
      )}
    </>
  );
};
export default CustomPrint;
